"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useFormContext_1 = require("../useFormContext");
const getForm = ({ state, control, Field }) => function Form({ children, onSubmit, ...props }) {
    return ((0, jsx_runtime_1.jsx)(useFormContext_1.FormProvider, { state: state, control: control, Field: Field, children: (0, jsx_runtime_1.jsx)("form", { onSubmit: onSubmit && control.onSubmit(onSubmit), ...props, children: children }) }));
};
exports.getForm = getForm;
//# sourceMappingURL=getForm.js.map